import React from 'react';

// import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { TextField } from '@material-ui/core';

/* const useStyles = makeStyles(theme => ({
    textField: {
      width: 200,
    },
    margin: {
      margin: theme.spacing(1),
    },
  })); */

const CheckBookEndorseForm = ({ findCustomer, onCloseDialogEndorse, openDialogEndorse, pristine,
    onAcceptClickEndorse, typeText, amount, description, selectedDate, owner }) => {
    let value = ''
    let disabled = true

    // const classes = useStyles();
    const handleOk = () => {
        onAcceptClickEndorse(value)
        onCloseDialogEndorse()
      // onClose(value);
    };
    /* const handleChange = event => {
        value = event.target.value
    }; */
    (owner !== '') && (disabled = false)
    return (
        <div>
            <Dialog
                open={ openDialogEndorse }
                onClose={ onCloseDialogEndorse }
                fullWidth={true}
                maxWidth= 'xs'
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{ 'Ingrese descripcion' }</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                    </DialogContentText>
                    <TextField
                        margin="normal"
                        fullWidth
                        name={'cedule'}
                        label={'Cedula'}
                        onChange = { (event) => ((event.target.value.length === 10 || event.target.value.lenght ===13) && findCustomer(event.target.value))}
                        // ref={withFocus && (txt => { this.txt = txt;} ) }
                    />
                    <TextField
                        margin="normal"
                        fullWidth
                        disabled
                        value = { owner }
                        name={'owner'}
                        label={'Propietario'}
                        // onChange = { () => { (owner !== '' ) ? disabled = '' : disabled = 'disabled' }}
                        // ref={withFocus && (txt => { this.txt = txt;} ) }
                    />
                    <TextField
                        margin="normal"
                        fullWidth
                        disabled
                        value = { amount }
                        name={'amount'}
                        label={'Monto'}
                        // ref={withFocus && (txt => { this.txt = txt;} ) }
                    />
                    <TextField
                        margin="normal"
                        fullWidth
                        disabled
                        value = { description }
                        name={'description'}
                        label={'descripcion'}
                        // ref={withFocus && (txt => { this.txt = txt;} ) }
                    />
                    <TextField
                        margin="normal"
                        fullWidth
                        disabled
                        value = { selectedDate }
                        name={'date'}
                        label={'Fecha'}
                        // ref={withFocus && (txt => { this.txt = txt;} ) }
                    />
                </DialogContent>
                <DialogActions>
                    <Button
                        color="primary"
                        disabled={ disabled }
                        onClick = {() => { handleOk() }}
                        fullWidth>
                        Aceptar
                    </Button>
                    <Button onClick={ onCloseDialogEndorse } color="primary">
                        Cancelar
                    </Button>
                </DialogActions>
        </Dialog>
        </div>
    );
};

export default CheckBookEndorseForm;